import { useEffect, useState } from "react";

export default function useAnnouncement(key) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const alreadySeen = localStorage.getItem(key);

    if (!alreadySeen) {
      setOpen(true);
    }
  }, [key]);

  const acknowledge = () => {
    localStorage.setItem(key, "true");
    setOpen(false);
  };

  return { open, acknowledge };
}
